import DropzoneContainer from '../../../Componant/BonusUi/Dropzone/Dropzone'

const Dropzone = () => {
  return (
    <div className='page-body'>
      <DropzoneContainer />
    </div>
  )
}

export default Dropzone